import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((res) => res, (err) => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 423 && (url.startsWith("/business") || url.startsWith("/auth/me"))) {
    localStorage.removeItem("gp_token");
    if (!window.location.pathname.startsWith("/login")) window.location.href = "/login?suspended=1";
  }
  return Promise.reject(err);
});

export default api;
